import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import Toggle from '../common/toggle'

type ToggleProps<IFormValues extends FieldValues> = {
    label: string
    description?: string
    name: Path<IFormValues>
    control: Control<IFormValues, any>
}

const ControlledToggle = <IFormValues extends FieldValues>({ label, description, name, control }: ToggleProps<IFormValues>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <Toggle
                    label={label}
                    error={fieldState.error?.message as any}
                    value={field.value}
                    onChange={(value) => field.onChange(value as any)}
                    description={description}
                />
            )}
        />
    )
}

export default ControlledToggle
